"use client";
import React from "react";
import { useIsMobile } from "@/hooks/useIsMobile";

const SliderSkeleton: React.FC = () => {
  const mobile = useIsMobile();
  // Matches the size in SliderWithThumbs (137px for PC)
  const thumbnailSize = 137; 
  const gap = 16;

  if (mobile) {
    return (
      <div className="w-100 p-4" style={{ position: "relative" }}>
        {/* Mobile only shows the main image slider area */}
        <div
          className="skeleton-rect"
          style={{
            width: "100%",
            paddingTop: "100%", // Square aspect ratio
            borderRadius: 16,
          }}
        />
      </div>
    );
  }

  return (
    <div
      className="w-100"
      style={{
        position: "relative",
        display: "flex",
        gap: gap,
      }}
    >
      {/* Thumbnails Column - Left side for PC */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 16,
          width: thumbnailSize,
          flexShrink: 0,
        }}
      >
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="skeleton-rect"
            style={{
              width: thumbnailSize,
              height: thumbnailSize,
              borderRadius: 16,
            }}
          />
        ))}
      </div>

      {/* Main Image - Right side for PC */}
      <div
        style={{
          flex: 1,
          position: "relative",
        }}
      >
        <div
          className="skeleton-rect"
          style={{
            width: "100%",
            paddingTop: "100%", // Square aspect ratio to match default ratio 1
            borderRadius: 16,
          }}
        />
      </div>
    </div>
  );
};

export default SliderSkeleton;
